import { useState } from 'react';
import clsx from 'clsx';
import { CaretDownNew } from '@hungryroot/icons';
import { TransparentButton, Heading } from '@hungryroot/ramen';
import styles from './ShowMore.module.css';

interface Props {
  expandedContent: string | JSX.Element | JSX.Element[];
  condensedContent: string | JSX.Element | JSX.Element[];
  className?: string;
  initialIsExpanded?: boolean;
  buttonClassName?: string;
  onShowMore?: (isExpanded: boolean) => void;
}

export function ShowMore(props: Props) {
  const {
    expandedContent,
    condensedContent,
    className,
    buttonClassName,
    initialIsExpanded = false,
    onShowMore,
  } = props;

  const [isExpanded, setIsExpanded] = useState(initialIsExpanded);

  return (
    <div className={`${styles.container} ${className}`}>
      {isExpanded ? expandedContent : condensedContent}
      <TransparentButton
        className={clsx(styles.button, buttonClassName)}
        onClick={() => {
          setIsExpanded(!isExpanded);
          onShowMore?.(isExpanded);
        }}
      >
        <Heading variant="H6" className={styles.heading}>
          {isExpanded ? 'Show less' : 'Show more'}
        </Heading>
        {isExpanded ? (
          <div className={styles.caret}>
            <CaretDownNew />
          </div>
        ) : (
          <CaretDownNew />
        )}
      </TransparentButton>
    </div>
  );
}
